'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var fr = {
  code: 'fr',
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: 'Précédent',
    next: 'Suivant',
    today: "Aujourd'hui",
    year: 'Année',
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour',
    list: 'Planning',
  },
  weekText: 'Sem.',
  allDayText: 'Toute la journée',
  moreLinkText: 'en plus',
  noEventsText: 'Aucun événement à afficher',
};

exports.default = fr;



//////////////////
// WEBPACK FOOTER
// /var/www/html/web/app/themes/isp-fourmies/node_modules/@fullcalendar/core/locales/fr.js
// module id = 172
// module chunks = 0